import PlayPauseButton from '../PlayPauseButton/PlayPauseButton';

import styles from './HighlightHeader.module.scss';
import { Highlight } from '../HighlightCard/HighlightCard';

interface Props {
  speaker: string;
  highlight: Highlight;
  audioUrl: string;
  onLogoClick: () => void;
  small: boolean;
}

const HighlightHeader = ({
  speaker,
  highlight,
  audioUrl,
  onLogoClick,
  small,
}: Props) => {
  // get date to display
  let fullDate = '';
  if (highlight.date) {
    fullDate = highlight.date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.leftHeader}>
          <PlayPauseButton
            audioUrl={audioUrl}
            data-testid="play-pause-button"
          />
          <div className={styles.headerText}>
            <div className={styles.speaker}>{speaker}</div>
            <div className={styles.location}>{fullDate}</div>
          </div>
        </div>
        {highlight.organization_logo && (
          <a
            href={highlight.organization_url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.logo}
            data-testid="organization-logo-button"
          >
            <img
              src={highlight.organization_logo}
              alt="Organization Logo"
              data-testid="organization-logo"
              style={{
                maxHeight: '50px',
                objectFit: 'contain',
              }}
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default HighlightHeader;
